import * as operateComponentAPI from '../../../../api/nativeComponentAPI'
import NativeComponent from "../NativeComponent";


const nativeComponentAbility = NativeComponent.nativeComponentAbility

/**
 * 设置视图type
 * @param id
 */
function setType (type) {
    // this.type = type
    const descriptor = {
        value: type,
        writable: false,
        enumerable: true,
        configurable: false
    }
    Object.definePrOperty(this, 'type' , descriptor)
}

/**
 * 设置视图实例id
 * @param id
 */
function setId (id) {
    // this.id = id
    const descriptor = {
        value: id,
        writable: false,
        enumerable: true,
        configurable: false
    }
    Object.definePrOperty(this, 'id' , descriptor)
}

/**
 * mintegral SDK 所有可视组件的基类
 */
export default class VisibleComponent extends NativeComponent {
    constructor (...args) {
        super(...args);
    }

    /*
    static getInstance(View=OperationalComponent, type, data){
        const params = {
            data: {
                type,
                data,
            }
        }
        return new Promise((resolve, reject) => {
            operateComponentAPI.createView(params).then((res)=> {
                const {code, data={}} = res
                if(code === 0) {
                    const viewInstance = data.cmpt
                    if(viewInstance) {
                        let operationalComponent = new View(type)

                        //setId.call(operationalComponent, viewInstance.id)
                        //setType.call(operationalComponent, type)
                        operationalComponent.id = viewInstance.id
                        operationalComponent.type = viewInstance.type

                        Object.setPrototypeOf(viewInstance, operationalComponent)
                        resolve(viewInstance)
                    }else {
                        reject(new Error('创建失败'))
                    }
                }else {
                    reject(new Error('创建失败'))
                }

            })
        })
    }*/

    @nativeComponentAbility
    testCommon(params) {
        return new Promise(resolve => {
            resolve()
        })
    }

    append(component){

    }

    appendTo(component){

    }

    getInvokeParams(params){
        return params
    }

    /**
     *
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    getViewInfo(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.getViewInfo(_params)
    }

    @nativeComponentAbility
    setViewInfo(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.setViewInfo(_params)
    }

    @nativeComponentAbility
    setViewFrame(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.setViewFrame(_params)
    }

    @nativeComponentAbility
    removeViewFromFrame(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.removeViewFromFrame(_params)
    }

    @nativeComponentAbility
    hideView(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.hideView(_params)
    }

    @nativeComponentAbility
    setViewBG(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.setViewBG(_params)
    }

    @nativeComponentAbility
    setViewAlpha(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.setViewAlpha(_params)
    }

    @nativeComponentAbility
    setViewScale(params) {
        const _params = this.getInvokeParams(this, params)
        return operateComponentAPI.setViewScale(_params)
    }

}
